import { Link } from "react-router-dom";
import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

export default function StoriesCta() {
  return (
    <section className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="bg-secondary-50 rounded-lg border border-secondary-200 p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-3 mb-5">
                <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
                <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                  Stay Connected
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
                New Stories, Farms & Experiences — Delivered to You
              </h2>
              <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl">
                Subscribe to Rythugaru for fresh farmer stories, seasonal experiences, rural
                destinations and upcoming events — straight to your inbox.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
              <Link
                to="/share-your-story"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Share your story
                <i className="ri-quill-pen-line"></i>
              </Link>
              <Link
                to="/#subscribe"
                className="inline-flex items-center justify-center gap-2 border border-background-300 text-foreground-800 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe to Rythugaru
                <i className="ri-mail-send-line"></i>
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}